// Copyright (c) 2017 Deere & Company

import './transfer-approvals.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import DuplicatePinPlateLinkPanel from '../../shared/components/duplicate-pin-plate-link';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import Facets from '../state/facets';
import {FormattedMessage} from 'react-intl';
import HighRentalDays from '../../search/components/high-rental-days';
import ProductReportLinks from '../../shared/components/product-report-links';
import ProductSearchBox from '../../shared/components/product-search-box';
import ProductsByCustomerLinkPanel from '../../shared/components/products-by-customer-link-panel';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import SearchDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../../shared/state/search-filters';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import State from '../state';
import TabNavigation from '../../../shared/components/tab-navigation';
import TransferApprovalFacets from './tranfer-approval-facets';
import TransferEnterAor from '@deere/cps-it.warranty-model-factory/lib/transfer-enter-aor';
import TransferList from './transfer-list';
import TransfersAcceptAll from './transfers-accept-all';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {getIsPinTransferEnabled} from '../../shared/services/get-is-pin-transfer-enabled-aor';
import {getNavigationTabs} from '../../shared/services/product-navigation-helper';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';
import {getStore} from '../../../store-factory';
import {getTransfersColumns} from '../services/excel-columns';
import {hasAccess} from '../../../shared/services/security';
import {hasPermission} from '../../../shared/services/privacy';
import {isEntitled} from '../../../shared/services/entitlements';

const filterOptions = [
    [
        'product',
        'pin'
    ],
    [
        'currentDealer',
        'account'
    ],
    [
        'currentDealer',
        'name'
    ],
    [
        'currentDealer',
        'location',
        'state'
    ],
    [
        'currentDealer',
        'location',
        'city'
    ],
    [
        'currentDealer',
        'location',
        'postalCode'
    ],
    [
        'newDealer',
        'account'
    ],
    [
        'newDealer',
        'name'
    ],
    [
        'newDealer',
        'location',
        'state'
    ],
    [
        'newDealer',
        'location',
        'city'
    ],
    [
        'newDealer',
        'location',
        'postalCode'
    ],
    [
        'requestedBy',
        'firstName'
    ],
    [
        'requestedBy',
        'lastName'
    ],
    [
        'product',
        'customerSummary',
        'displayName'
    ],
    ['reasonForChange'],
    [
        'recommendation',
        'workOrderNumber'
    ]
];

const sortOptions = [
    {
        displayName: 'REQUESTED',
        path: ['requestDate']
    },
    {
        displayName: 'CURRENT_DEALER_LOCATION',
        path: [
            'currentDealer',
            'account'
        ]
    },
    {
        displayName: 'NEW_DEALER_LOCATION',
        path: [
            'newDealer',
            'account'
        ]
    }
];

function updateRequestedDateRangeFacet(requestedDates) {

    this.props.actions.updateRequestedDateRangeFacet(requestedDates);

}

function applyTransferApprovalFacets() {

    this.props.actions.updateTransferResultsWithFacets(false);

}

function resetTransferApprovalFacets() {

    this.props.actions.resetTransferResults(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleDealerFilterInput(text) {

    this.props.actions.updateDealerAccountFacetInput(text);

}

function updateTransferApprovalFacetItem(item, isSelected) {

    this.props.actions.updateTransferApprovalFacetItem(item, isSelected);

}

function toggleTransferApprovalFacetItems() {

    this.props.actions.toggleTransferApprovalFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function handleAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.transfers.name, this.exportToExcel.selectedExcelLayout.transfers.listId, 'transfers');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.transfers.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'transfers');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('transfers');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'transfers');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.transfers.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('transfers', this.exportToExcel.selectedExcelLayout.transfers.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.transfers);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'transfers');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('transfers', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'transfers');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleDownloadToExcel() {

    this.actions.exportToExcel(
        this.facets,
        this.user.getLocale(),
        this.exportToExcel.selectedExcelLayout.transfers.name,
        this.exportToExcel.selectedExcelLayout.transfers.listId
    );

}

function handleHighRentalDaysDownloadToExcel() {

    this.actions.highRentalDaysExportToExcel(
        this.user.settings,
        this.user.getLocale()
    );

}

class TransferApprovals extends Component {

    /* eslint-disable complexity */

    componentWillMount() {

        if (this.props.facets.dealerAccountsFacet.isInitialLoad || !this.props.facets.dealerAccountsFacet.selectedDealers.length) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        this.props.actions.updateTransferResultsWithFacets(true);
        this.props.actions.highOnRentalDays(this.props.user.settings);
        this.props.actions.readMachineStatusUpdates(this.props.facets.dealerAccountsFacet.allowedDealers);
        if (getIsPinTransferEnabled('pin-transfer-aor')) {

            this.props.actions.getRejectedReason(this.props.user.getLocale());

        }
        if (hasAccess(this.props.security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE')) {

            this.props.actions.updateFactoryDuplicatePinPlateResults();

        }

    }

    componentWillUnmount() {

        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        const countObject = {
            dealerRecommendations: this.props.dealerRecommendationCount,
            factoryDuplicatePinPlateCount: this.props.duplicatePinPlateCount,
            machineStatusUpdates: this.props.machineStatusUpdateCount,
            productSearch: this.props.searchResultsCount,
            registrationReview: this.props.registrationReviewCount,
            transferApproval: this.props.transfers.length <= 0 ? this.props.transferApprovalsCount : this.props.transfers.length
        };

        let sortedCollection;

        sortedCollection = [...this.props.transfers];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, filterOptions, sortedCollection);
        return (
            <div className='transfer-approvals'>
                <aside>
                    <TransferApprovalFacets
                        dateFormat={this.props.dateFormat}
                        dealerAccountsFacet={this.props.facets.dealerAccountsFacet}
                        onApply={this::applyTransferApprovalFacets}
                        onCheckboxListChange={this::updateTransferApprovalFacetItem}
                        onDatePickerChange={this::updateRequestedDateRangeFacet}
                        onInputChange={this::handleDealerFilterInput}
                        onReset={this:: resetTransferApprovalFacets}
                        onToggleAll={this::toggleTransferApprovalFacetItems}
                        requestedDateRange={this.props.facets.requestedDateRange}
                    />
                    <HighRentalDays
                        highRentalDaysCount={this.props.highRentalDaysCount}
                        onExport={this.props::handleHighRentalDaysDownloadToExcel}
                    />
                    {!this.props.user.privacy.customerPrivate && this.props.isSapUp &&
                        <ProductsByCustomerLinkPanel/>
                    }
                    {isEntitled(getStore().getState().user.entitlements, 'duplicatepins') > 0 &&
                    <DuplicatePinPlateLinkPanel/>
                    }
                    <div className='report-links'>
                        <ProductReportLinks
                            onAccordionToggle={this.props::handleAccordionToggle}
                            reportsAccordion={this.props.reportsAccordion}
                            reportsRoutes={this.props.reportsRoutes}
                        />
                    </div>
                </aside>
                <main>
                    <div className='primary-actions'>
                        {hasAccess(this.props.security, 'PRT', 'PRT_REGISTER_PRODUCT') && hasPermission(this.props.user.privacy, 'registrationNotAllowed') &&
                            <a
                                className='primary-action'
                                href={'#/products/register-product'}
                            >
                                <FormattedMessage id='REGISTER_PRODUCT'/>
                            </a>
                        }
                    </div>
                    <ProductSearchBox
                        handleSearch={this.props::handleSearch}
                        searchByDropDown={this.props.searchByDropDown}
                        searchQueryString={this.props.searchQueryString}
                        updateSearchDropDown={this.props.actions.updateSearchDropDown}
                        updateSearchQueryString={this.props.actions.updateSearchQueryString}
                    />
                    <div className='transfer-search-tabs'>
                        <TabNavigation
                            tabs={getNavigationTabs(countObject, this.props.hasSearchResults, this.props.security)}
                        />
                        {this.props.transfers.length > 0 &&
                            <TransfersAcceptAll
                                transfers={this.props.transfers}
                                updateAction={this.props.actions.updateTransferStatus}
                            />
                        }
                    </div>
                    <TransferList
                        transfers={sortedCollection}
                        updateCommentAction={this.props.actions.updateTransferComment}
                        updateRejectedReason={this.props.actions.updateRejectedReason}
                        updateStatusAction={this.props.actions.updateTransferStatus}
                    >
                        <RefinableListWidgetWithExportAndLayouts
                            excelLayouts={this.props.exportToExcel.excelLayouts.transfers}
                            onCreateLayout={this.props::handleCreateExcelLayout}
                            onEditLayout={this.props::handleEditExcelLayout}
                            onExport={this.props::handleDownloadToExcel}
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onLayoutChange={this.props::handleExcelLayoutChange}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            selectedLayout={this.props.exportToExcel.selectedExcelLayout.transfers}
                            sortOptions={sortOptions}
                            type={State}
                        />
                    </TransferList>
                    <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                    <ExcelLayoutModal
                        excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                        mappingTable={getTransfersColumns().listColumns}
                        onColumnMove={this.props::handleColumnMove}
                        onColumnPush={this.props::handleColumnPush}
                        onColumnRemove={this.props::handleColumnRemove}
                        onLayoutDelete={this.props::handleExcelLayoutDelete}
                        onLayoutNameBlur={this.props::handleLayoutNameBlur}
                        onLayoutNameChange={this.props::handleLayoutNameChange}
                        onModalClose={this.props::handleExcelLayoutModalClose}
                        onSaveLayout={this.props::handleSaveExcelLayout}
                        onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        sortByList={getSortByList(getTransfersColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                    />
                </main>
            </div>
        );

    }

}

/* eslint-enable complexity */

TransferApprovals.displayName = 'TransferApprovals';
TransferApprovals.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dateFormat: PropTypes.string.isRequired,
    dealerRecommendationCount: PropTypes.number,
    duplicatePinPlateCount: PropTypes.number,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    hasSearchResults: PropTypes.bool.isRequired,
    highRentalDaysCount: PropTypes.number.isRequired,
    isSapUp: PropTypes.bool.isRequired,
    machineStatusUpdateCount: PropTypes.number,
    registrationReviewCount: PropTypes.number,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchDropDown),
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired,
    searchResultsCount: PropTypes.number.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    transferApprovalsCount: PropTypes.number,
    transfers: PropTypes.arrayOf(PropTypes.instanceOf(TransferEnterAor)).isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default TransferApprovals;



// WEBPACK FOOTER //
// ./src/product/transfers/components/transfer-approvals.js